enum SubscriptionTypeEnum {
  PubSub = 'PubSub',
  WebSocket = 'WebSocket',
}

export default SubscriptionTypeEnum;
